type SameOriginLocation = Pick<Location, 'protocol' | 'host'>;

export function buildSameOriginUrl(location: SameOriginLocation, path: string): string {
  return `${location.protocol}//${location.host}${path}`;
}
